import { forwardRef, useEffect } from "react";
import { usePrevious } from "../../../../hooks/usePrevious/index.js";
import { StyledSidebarInner } from "./style.js";
import { SidebarInnerProps } from "./types.js";

export const SidebarInner = forwardRef<HTMLDivElement, SidebarInnerProps>(
    (
        {
            onEnteredChange,
            onEnteredChangeAfterTransition,
            transitionDuration,
            transitionState,
            open,
            backgroundColor,
            floating,
            children,
            ...attributes
        },
        ref,
    ) => {
        const previousTransitionState = usePrevious(transitionState);
        const previousEnteredState = usePrevious(transitionState === "entered");

        useEffect(() => {
            if ((!onEnteredChange && !onEnteredChangeAfterTransition) || previousTransitionState === transitionState) {
                return;
            }
            const newEnteredState = transitionState === "entered";
            if (previousEnteredState === newEnteredState) {
                return;
            }

            onEnteredChange?.(newEnteredState);

            if (onEnteredChangeAfterTransition) {
                if (transitionState === "entered") {
                    const timer = setTimeout(() => {
                        onEnteredChangeAfterTransition?.(newEnteredState);
                    }, transitionDuration);
                    // eslint-disable-next-line consistent-return
                    return () => clearTimeout(timer);
                }
                onEnteredChangeAfterTransition?.(newEnteredState);
            }
        }, [transitionState]);

        return (
            <StyledSidebarInner
                {...attributes}
                ref={ref}
                transitionDuration={transitionDuration}
                transitionState={transitionState}
                open={open}
                backgroundColor={backgroundColor}
                floating={floating}
            >
                {children}
            </StyledSidebarInner>
        );
    },
);
